import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n/I18nContext";
import { AuthCallback } from "@/components/AuthCallback";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import NewDocument from "@/pages/NewDocument";
import CaseNew from "@/pages/CaseNew";
import CaseDetail from "@/pages/CaseDetail";
import Documents from "@/pages/Documents";
import DocumentAnalysis from "@/pages/DocumentAnalysis";
import Subscription from "@/pages/Subscription";

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAF8]">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#2D5A4C] border-t-transparent" />
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();

  // Handle Google OAuth callback synchronously during render (before ProtectedRoute).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
      <Route path="/documents/new" element={<ProtectedRoute><NewDocument /></ProtectedRoute>} />
      <Route path="/documents/:id/analysis" element={<ProtectedRoute><DocumentAnalysis /></ProtectedRoute>} />
      <Route path="/cases" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/cases/new" element={<ProtectedRoute><CaseNew /></ProtectedRoute>} />
      <Route path="/cases/:id" element={<ProtectedRoute><CaseDetail /></ProtectedRoute>} />
      <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
